export default "__VITE_ASSET__na6aQv62__ 1600w, __VITE_ASSET__fS6A_dtz__ 800w";